<script setup lang="ts">
defineProps({
    classes: {
        type: String,
        default: ''
    }
});

const titleClasses = [
    'text-4xl md:text-4.63xl',
    'lg:text-5xl xl:text-5.25xl font-bold text-center',
].join(' ');
</script>

<template>
    <h2 :class="[titleClasses, classes]">
        <slot/>
    </h2>
</template>

<style scoped>

</style>
